import { FC, useContext, useMemo } from 'react';

import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';
import { StepThreeFormContext } from '../../../StepThree/contexts/StepThreeForm';

import {
  GenericDataFormContext,
  GroupedCoverageCardsList,
  QuotationInfoContext,
} from '../../../../../shared';

import {
  groupCardsByCommonSection,
  GroupedCoveragesCardsResult,
} from '../../../../../utils';
import { ContentSection } from '../../../../../../../../../shared/components';

interface CoveragesHomeSectionProps {
  tabKey: number | string;
}

export const CoveragesHomeSection: FC<CoveragesHomeSectionProps> = ({
  tabKey,
}) => {
  const { stepThreeHomeQuotationForm } = useContext(StepThreeFormContext);
  const { allCoveragesPerPlan, getRelationWithOtherCoverage } = useContext(GenericDataFormContext);
  const { stepTwoForm } = useContext(StepTwoFormContext);
  const { quotationInfo } = useContext( QuotationInfoContext );

  const planSelected = stepTwoForm?.getFieldValue(`plan-tab-${tabKey}`);

  const allCoveragesByTab = useMemo(
    () =>
      allCoveragesPerPlan.find((el) => (el.plan as string) === planSelected)
        ?.coverages,
    [allCoveragesPerPlan, planSelected]
  );

  const groupedCoveragesCardsResult: GroupedCoveragesCardsResult =
  useMemo(() => {
    return allCoveragesByTab
      ? groupCardsByCommonSection(allCoveragesByTab, 'codigoFamilia')
      : {};
  }, [allCoveragesByTab]);

  return (
    <ContentSection level='h3' title='Coberturas' hasCard={false}>
      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (!groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`home-tab-${tabKey}`}
              usedFormToCoverageCard={stepThreeHomeQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
            />
          );
        }
      })}

      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`home-tab-${tabKey}`}
              usedFormToCoverageCard={stepThreeHomeQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
            />
          );
        }
      })}
    </ContentSection>
  );
};
